import NotImmplemented from "./NotImplemented"
import "../App.css"

const Language = () => {
  return (
    <div className="modalContainer">
      <h3>Language</h3>
      <NotImmplemented />
    </div>
  )
}

export default Language
